import { MenuItem, Stack, Typography } from '@mui/material';
import FR from 'country-flag-icons/react/3x2/FR';
import GB from 'country-flag-icons/react/3x2/GB';

import { FSTextField } from '@/ui/components/input/FSTextField';
import {
  AppLanguage,
  changeAppLanguageAndReload,
  language,
  translate,
} from '@/ui/i18n';

export function PreferencesSection() {
  return (
    <Stack sx={{ gap: 3 }}>
      <PreferencesForm />
    </Stack>
  );
}

function PreferencesForm() {
  const currentAppLanguage = language;

  function onChange(lang: AppLanguage) {
    changeAppLanguageAndReload(lang);
  }

  return (
    <FSTextField
      select
      label={translate('Settings.Preferences.language')}
      value={currentAppLanguage}
      onChange={(e) => onChange(e.target.value as 'fr' | 'en')}
    >
      <MenuItem value="fr">
        <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 1 }}>
          <FR style={{ width: 20 }} />
          <Typography>{translate('Settings.Preferences.french')}</Typography>
        </Stack>
      </MenuItem>
      <MenuItem value="en">
        <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 1 }}>
          <GB style={{ width: 20 }} />
          <Typography>{translate('Settings.Preferences.english')}</Typography>
        </Stack>
      </MenuItem>
    </FSTextField>
  );
}
